import { CloseOutlined } from '@mui/icons-material';
import { Button, Grid, IconButton, Typography } from '@mui/material';
import _ from 'lodash';
import moment from 'moment';
import React, { useState } from 'react'
import CustomTable from '../customTable';
const SingleMember = ({monthData , setName,setOpen,name,pageCountMember,setPageCountMember,pageMember,rowsPerPageMember,pageOptionMember,setRowsPerPageMember,setPageMember}) => {
    console.log(monthData)
    const columns = [
        {
          field: "sno",
          headerName: "S.no",
          minWidth: 50,
          maxWidth: 50,
          headerAlign: "center",
          align: "center",
          sortable: false,
        },
        {
            field: "date",
            headerName: "Date",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
        {
            field: "code",
            headerName: "Code",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "docNo",
            headerName: "Doc No",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
        
        {
          field: "partyName",
          headerName: "Party Name",
          flex: 1,
          headerAlign: "center",
          align: "center",
          sortable: false,
        },
       
        {
          field: "mobile",
          headerName: "Mobile",
          flex: 1,
          headerAlign: "center",
          align: "center",
          sortable: false,
        },
        {
            field: "mode",
            headerName: "Mode",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "loyalty_earned",
            headerName: "Loyalty Earned",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "loyalty_redem",
            headerName: "Loyalty Redem",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
        {
          field: "balancePoints",
          headerName: "Balance Points",
          flex: 1,
          headerAlign: "center",
          align: "right",
          sortable: false,
          renderCell: (params) => (
            <strong>{params.value}</strong>
          ),
        },
        {
            field: "amount",
            headerName: "Amount",
            flex: 1,
            headerAlign: "center",
            align: "right",
            sortable: false,
            renderCell: (params) => (
              <strong>{params.value}</strong>
            ),
          },
      ];
    
      const rows = _.map(monthData, (val, idx) => ({
        id: idx,
        sno: idx + 1,
        date: moment(val.docdate).format('DD-MM-YYYY'),
        partyName: val.party_name || '-',
        mobile: val.mobile ,
        balancePoints: val.balance_points || '-',
        amount: val.amount || '-',
        code:val.code || '-',
        docNo:val.docno.replace("_", "/").replace("_", "-").replace("_", "/"),
        mode:val.mode,
        loyalty_earned:val.loyalty_earned,
        loyalty_redem:val.loyalty_redem
      }));
      const props = {
        columns : columns,
        rows : rows,
        page: pageMember,
        setPage: setPageMember,
        rowsPerPage: rowsPerPageMember,
        setRowsPerPage: setRowsPerPageMember,
        pageCount: pageCountMember,
        pageOption: pageOptionMember,
      }
  return (
    <Grid>
        <Grid sx={{display:"flex" , justifyContent:"space-between",padding:1,alignItems:"center"}}>
            <Typography variant='h6'>Member Report : <span style={{fontWeight:"600",color:"#A06EE1"}}>{name}</span></Typography>
            <IconButton onClick={() => {setOpen(false);setName('') }}>
                <CloseOutlined />
            </IconButton>
        </Grid>
        <Grid>
        <CustomTable props={props}/>

        </Grid>
    </Grid>
  )
}

export default SingleMember